"use client";

import clsx from "clsx";
import styles from "./description.module.css";

interface IExpandDescriptionButtonProps {
  className?: string;
  toggleExpand: () => void;
  isExpanded: boolean;
}

export const ExpandDescriptionButton = ({
  className = "",
  toggleExpand,
  isExpanded
}: IExpandDescriptionButtonProps) => {
  return (
    <button className={clsx(styles.readMore, className)} onClick={toggleExpand}>
      {isExpanded ? "Les mer" : "Les mindre"}
    </button>
  );
};
